var map = {
	"./img.jpg": "e85b",
	"./img1.jpg": "140a",
	"./img2.jpg": "a891",
	"./img3.jpg": "ed89",
	"./img4.jpg": "caf4",
	"./img5.jpg": "da3f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d8ae";